import React from 'react';
import { Settings } from 'lucide-react';
import { motion } from 'framer-motion';

export function MaintenancePage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 text-white p-6">
      <motion.div
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, type: 'spring', stiffness: 120 }}
        className="flex flex-col items-center text-center bg-black/30 backdrop-blur-md p-8 sm:p-12 rounded-2xl shadow-2xl border border-white/10"
      >
        <motion.div
          animate={{ rotate: [0, 360] }}
          transition={{ duration: 10, repeat: Infinity, ease: 'linear' }}
        >
          <Settings className="w-16 h-16 sm:w-24 sm:h-24 text-cyan-400 mb-6 sm:mb-8 drop-shadow-[0_0_15px_rgba(56,189,248,0.5)]" />
        </motion.div>
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4 bg-gradient-to-r from-purple-400 via-blue-400 to-cyan-400 bg-clip-text text-transparent">
          App Under Maintenance
        </h1>
        <p className="text-lg sm:text-xl text-slate-300 max-w-md">
          We're currently performing some scheduled maintenance. Sonic Groove will be back online shortly. Thanks for your patience!
        </p>
        <motion.div 
          className="mt-8 w-full max-w-xs h-1 bg-cyan-400/50 rounded-full overflow-hidden"
        >
          <motion.div 
            className="h-full bg-gradient-to-r from-purple-500 to-cyan-400"
            initial={{ x: "-100%" }}
            animate={{ x: "100%" }}
            transition={{ duration: 2, repeat: Infinity, ease: "linear", repeatType: "loop" }}
          />
        </motion.div>
      </motion.div>
    </div>
  );
}